import './HeroInfo.css';

const HeroInfo = () => {
  return (
    <section className="hero-info" id="hero-info">
      <div className="hero-info-container">
        <div className="hero-info-content" data-aos="fade-up">
          <h2>Por que escolher a ACJ?</h2>
          <p className="hero-info-highlight">
            Há mais de uma década transformando eventos em experiências memoráveis através 
            da tecnologia LED de última geração.
          </p>
          
          <div className="hero-info-grid">
            <div className="info-card" data-aos="fade-up" data-aos-delay="100">
              <h3>Expertise Comprovada</h3>
              <p>
                Com mais de 10 anos no mercado, a ACJ se consolidou como líder em 
                soluções audiovisuais para eventos. Nossa experiência garante a 
                execução impecável do seu projeto, do planejamento à entrega.
              </p>
            </div>

            <div className="info-card" data-aos="fade-up" data-aos-delay="200">
              <h3>Tecnologia Premium</h3>
              <p>
                Investimos constantemente em equipamentos de última geração, oferecendo 
                painéis de LED com resolução Ultra HD, brilho excepcional e cores 
                vibrantes que garantem uma experiência visual extraordinária.
              </p>
            </div>

            <div className="info-card" data-aos="fade-up" data-aos-delay="300">
              <h3>Equipe Especializada</h3>
              <p>
                Nossa equipe técnica altamente qualificada está preparada para 
                oferecer suporte completo durante todo o evento, garantindo uma 
                execução perfeita e tranquilidade para nossos clientes.
              </p>
            </div>

            <div className="info-card" data-aos="fade-up" data-aos-delay="400">
              <h3>Compromisso com Excelência</h3>
              <p>
                Cada projeto é tratado com dedicação exclusiva, garantindo que sua 
                visão seja perfeitamente executada. Nossa obsessão por qualidade 
                se reflete em cada detalhe do seu evento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroInfo; 
